export default "__VITE_ASSET__RkDoXRZ$bx$5lf1haFcvQA__"